import React from 'react';

import { ActionBar, Stack } from '@gogame/components';
import { useChildComponent } from '@gogame/hooks-ts';

import TrackerActions from './Actions';
import { PathBuilder } from './PathBuilder';
import { TrackerBreadcrumbsBar } from './TrackerBreadcrumbsBar';

export function CohortToolbar({
  dimensions,
  drillTo,
  onChangeNextLevel,
  nextLevel,
  drillItems,
  onExport,
  onExportGoogleDrive,
  onExportWhenReady,
  onOpenSubscriptionsForm,
  onChangeDrillPath,
}) {
  const [content, setContent] = useChildComponent();

  return (
    <Stack sx={{ width: '100%' }}>
      <ActionBar
        secondaryActions={
          <TrackerActions
            setContent={setContent}
            onExport={onExport}
            onExportGoogleDrive={onExportGoogleDrive}
            onExportWhenReady={onExportWhenReady}
            onOpenSubscriptionsForm={onOpenSubscriptionsForm}
            disabledAdvancedFilters={true}
            disabledCustomizeColumns={true}
          />
        }
      >
        <PathBuilder
          dimensions={dimensions}
          drillTo={drillTo}
          nextLevel={nextLevel}
          onChangeNextLevel={onChangeNextLevel}
        />
      </ActionBar>
      {content}
      {drillItems?.length > 1 && (
        <TrackerBreadcrumbsBar
          value={drillItems}
          onChange={onChangeDrillPath}
        />
      )}
    </Stack>
  );
}
